<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Convertir Prospecto</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="stepper">
                <div class="step" [ngClass]="{'active-step': step === 1, 'completed-step': step > 1}">
                    <div class="step-number">1</div>
                    <div class="step-label">Cuenta</div>
                </div>
                <div class="step" [ngClass]="{'active-step': step === 2, 'completed-step': step > 2}">
                    <div class="step-number">2</div>
                    <div class="step-label">Contacto</div>
                </div>
                <div class="step" [ngClass]="{'active-step': step === 3, 'completed-step': step > 3}">
                    <div class="step-number">3</div>
                    <div class="step-label">Oportunidad</div>
                </div>
                <div class="step" [ngClass]="{'active-step': step === 4, 'completed-step': step > 4}">
                    <div class="step-number">4</div>
                    <div class="step-label">Resumen</div>
                </div>
            </div>
            @if(step === 1){
            <div class="d-grid convert-tab mt-5">
                <div class="d-flex flex-row" style="column-gap: 8px;">
                    <img src="assets/svg/account-icon.svg" alt="">
                    <h6 class="text-semibold">Cuenta</h6>
                </div>
                <div>
                    <img src="assets/svg/arrow-down-black.svg" alt="" class="center-svg">
                </div>
            </div>
            <div class="step-1">
                <div class="d-grid form-convert mt-3 gap-16">
                    <div>
                        <label class="crm-radio-label">
                            <input type="radio" class="crm-radio" value="new" name="new-account" [(ngModel)]="accountType" checked>
                            <span class="crm-radio-custom"></span>
                            <h6 class="text-semibold">Crear cuenta nueva</h6>
                        </label>
                    </div>
                    <div>
                        <label class="crm-radio-label">
                            <input type="radio" class="crm-radio" value="existing" name="new-account" [(ngModel)]="accountType">
                            <span class="crm-radio-custom"></span>
                            <h6 class="text-semibold">Elegir cuenta existente</h6>
                        </label>
                    </div>
                </div>
                @if(accountType === 'existing') {
                    <div class="main-step">
                        <h5 class="text-semibold mt-4">Seleccionar cuenta existente</h5>
                        <div class="mt-3">
                            <div class="d-grid prospect-form">
                                <div>
                                    <label class="login-label" for="existing-account"><span class="color-org">*</span> Búsqueda de cuenta:</label>
                                    <div class="input-bordered">
                                        <div class="d-grid crm-ng-select">
                                            <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                                            <div>
                                                <ng-select
                                                    *ngIf="accounts"
                                                    [items]="accounts"
                                                    bindLabel="nombre_empresa"
                                                    bindValue="cuenta_id"
                                                    placeholder="Seleccionar cuenta..."
                                                    [(ngModel)]="cuentaExistente"
                                                    [searchable]="true"
                                                    [clearable]="true">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if(accountType === 'new') {
                <div class="main-step">
                    <h5 class="text-semibold mt-4">Informaci&oacute;n de la cuenta</h5>
                    <form #accountForm="ngForm">
                    <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div>
                            <div class="mt-3">
                                <label class="login-label" for="name"><span class="color-org" *ngIf="!acc_request.nombre_empresa || acc_request.nombre_empresa.trim() === ''">*</span> Nombre de la cuenta:</label>
                                <input class="crm-input" type="text" name="name" id="name" [(ngModel)]="acc_request.nombre_empresa" #nameCtrl="ngModel" placeholder="Siroe" required />
                                <div class="error-text" *ngIf="nameCtrl.invalid && nameCtrl.touched">
                                    <small *ngIf="nameCtrl.errors?.['required']">Este campo es obligatorio.</small>
                                </div>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="divisa"><span class="color-org" *ngIf="!acc_request.divisa_cuenta|| acc_request.divisa_cuenta.trim() === ''">*</span> Divisa de la cuenta:</label>
                                <select class="crm-input" name="divisa" id="divisa" [(ngModel)]="acc_request.divisa_cuenta" #divisaCtrl="ngModel" required>
                                    <option value="" disabled selected>Seleccionar divisa de la cuenta</option>
                                    <option value="CLP">CLP</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                </select>
                            <div class="error-text" *ngIf="divisaCtrl.invalid && (divisaCtrl.dirty || divisaCtrl.touched)">
                            <small *ngIf="divisaCtrl.errors?.['required']">Debe seleccionar una divisa.</small>
                            </div>
                            </div>
                        </div>
                        <div>
                            <div class="mt-3">
                                <label class="login-label" for="rut"><span class="color-org" *ngIf="!acc_request.rut || acc_request.rut.trim() === ''">*</span> RUT:</label>
                                <input class="crm-input" type="text" name="rut" id="rut" [value]="cuenta?.rut" [(ngModel)]="acc_request.rut" placeholder="77.123.456-7" required #rutCtrl="ngModel"   pattern="^(\d{1,2}\.?\d{3}\.?\d{3}-[\dkK])$" title="Ingrese un RUT válido. Ejemplo: 12.345.678-9" />
                                <div class="error-text" *ngIf="rutCtrl.invalid && (rutCtrl.dirty || rutCtrl.touched)">
                                <small *ngIf="rutCtrl.errors?.['required']">El RUT es obligatorio.</small>
                                <small *ngIf="rutCtrl.errors?.['pattern']">El formato del RUT no es válido.</small>
                                </div>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="telefono"><span class="color-org" *ngIf="!acc_request.telefono || acc_request.telefono.trim() === ''">*</span>Teléfono:</label>
                                <input class="crm-input" type="text" name="telefono" id="telefono" [value]="cuenta?.telefono" [(ngModel)]="acc_request.telefono" placeholder="+56 2 2134 5678" #telefonoCtrl="ngModel" required pattern="^\+?\d{0,15}$" inputmode="numeric" title="Ingrese solo números. Ejemplo: +56912345678" />
                                <div class="error-text" *ngIf="telefonoCtrl.invalid && (telefonoCtrl.dirty || telefonoCtrl.touched)">
                                <small *ngIf="telefonoCtrl.errors?.['required']">El teléfono es obligatorio.</small>
                                <small *ngIf="telefonoCtrl.errors?.['pattern']">Ingrese un número de teléfono válido.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="propietario">Propietario de la cuenta:</label>
                        <div class="d-flex flex-row align-items-center color-org gap-10">
                            <img src="assets/svg/avatar.svg" alt="">
                        <b><u>
                        {{ data.mode === 'edit'
                            ? cuenta?.ejecutivo?.nombre + ' ' + cuenta?.ejecutivo?.apellido
                            : loggedUserName }}
                        </u></b>
                        </div>
                    </div>

                    <h5 class="text-semibold mt-4">Informaci&oacute;n adicional</h5>
                    <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div>
                            <div class="mt-3">
                                <label for="industria" class="login-label"><span class="color-org" *ngIf="!acc_request.industria_id|| acc_request.industria_id.trim() === ''">*</span>Industria:</label>
                                <select class="crm-input" name="industria" id="industria" [(ngModel)]="acc_request.industria_id" #industriaCtrl="ngModel">
                                    <option value="" disabled selected>Seleccionar tipo de industria</option>
                                    @for (industria of industrias; track industria) {
                                        <option [value]="industria.industria_id" [selected]="acc_request?.industria_id === industria.industria_id">{{ industria.nombre }}</option>
                                    }
                                </select>
                            </div>
                            <div class="mt-3">
                                <label for="website" class="login-label"><span class="color-org" *ngIf="!acc_request.sitio_web|| acc_request.sitio_web.trim() === ''">*</span>Sitio web:</label>
                                <input class="crm-input" type="text" name="website" id="website" placeholder="www.siroe.cl" [value]="cuenta?.sitio_web" #sitwebCtrl="ngModel" [(ngModel)]="acc_request.sitio_web" >

                            </div>
                            <div class="mt-3">
                                <label for="linkedin" class="login-label"><span class="color-org" *ngIf="!acc_request.linkedin || acc_request.linkedin.trim() === ''">*</span>Linkedin empresa:</label>
                                <input class="crm-input" type="text" name="linkedin" id="linkedin" placeholder="Chile" [value]="cuenta?.linkedin" #linkeCtrl="ngModel" [(ngModel)]="acc_request.linkedin" >
                            </div>
                        </div>
                        <div>
                            <div class="mt-3">
                                <label for="subfamilia" class="login-label"><span class="color-org" *ngIf="!acc_request.subfamilia|| acc_request.subfamilia.trim() === ''">*</span>Subfamilia</label>
                                <select class="crm-input" name="subfamilia" id="subfamilia" [(ngModel)]="acc_request.subfamilia" #subfamCrtrl="ngModel" >
                                    <option value="" disabled selected>Seleccionar tipo de subfamilia</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                </select>
                            </div>
                            <div class="mt-3">
                                <label for="empleados" class="login-label"><span class="color-org" *ngIf="!acc_request.empleados">*</span>Cantidad empleados:</label>
                                <input class="crm-input" type="number" min="0" name="empleados" id="empleados" placeholder="50" [value]="acc_request.empleados" #empleadosCtrl="ngModel" [(ngModel)]="acc_request.empleados" >
                            </div>
                            <div class="mt-3">
                                <label for="descripcion" class="login-label"><span class="color-org"  *ngIf="!acc_request.descripcion|| acc_request.descripcion.trim() === ''">*</span>Descripci&oacute;n</label>
                                <input class="crm-input" name="descripcion" id="descripcion" rows="4" placeholder="Agrega descripción de la cuenta (opcional)" #descripcionCtrl="ngModel" [(ngModel)]="acc_request.descripcion" >
                            </div>
                        </div>
                    </div>

                    <div class="d-grid prospect-form mt-3" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div>
                            <h5 class="text-semibold mt-4">Dirección de facturación</h5>
                            <div class="mt-3">
                                <label class="login-label" for="calle_fact"><span class="color-org" *ngIf="!acc_request.calle_fact|| acc_request.calle_fact.trim() === ''">*</span>Calle:</label>
                                <input class="crm-input" type="text" name="calle_fact" id="calle_fact" [(ngModel)]="acc_request.calle_fact" #calleFactCtrl="ngModel" placeholder="Av. Libertador 1234" >
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="region_fact"><span class="color-org" *ngIf="!acc_request.region_fact|| acc_request.region_fact.trim() === ''">*</span>Región</label>
                                <select class="crm-input" name="region_fact" id="region_fact" [(ngModel)]="acc_request.region_fact" (change)="getComunasFact(acc_request.region_fact)" >
                                    @for(item of regiones; track item.NombreRegion){
                                        <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                                    }
                                </select>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="ciudad_fact"><span class="color-org" *ngIf="!acc_request.ciudad_fact|| acc_request.ciudad_fact.trim() === ''">*</span>Comuna</label>
                                <select class="crm-input"name="ciudad_fact" id="ciudad_fact" [(ngModel)]="acc_request.ciudad_fact" >
                                    @for (comuna of comunas; track comuna) {
                                        <option [value]="comuna">{{ comuna }}</option>
                                    }
                                </select>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="pais_fact">País</label>
                                <input class="crm-input" name="pais_fact" type="text" id="pais_fact" [(ngModel)]="acc_request.pais_fact" disabled>
                            </div>
                        </div>
                        <div>
                            <h5 class="text-semibold mt-4">Dirección de envío</h5>
                            <div class="mt-3">
                                <label class="login-label" for="calle_env"><span class="color-org" *ngIf="!acc_request.calle_env|| acc_request.calle_env.trim() === ''">*</span>Calle:</label>
                                <input class="crm-input" name="calle_env" type="text" id="calle_env" [(ngModel)]="acc_request.calle_env" placeholder="Av. Libertador 1234" #calleEnvCtrl="ngModel" >
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="region_env"><span class="color-org" *ngIf="!acc_request.region_env|| acc_request.region_env.trim() === ''">*</span>Región</label>
                                <select class="crm-input" name="region_env" id="region_env" [(ngModel)]="acc_request.region_env" (change)="getComunasEnv(acc_request.region_env)" >
                                    @for(item of regiones; track item.NombreRegion){
                                        <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                                    }
                                </select>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="ciudad_env"><span class="color-org" *ngIf="!acc_request.ciudad_env|| acc_request.ciudad_env.trim() === ''">*</span>Comuna</label>
                                <select class="crm-input" name="ciudad_env" id="ciudad_env" [(ngModel)]="acc_request.ciudad_env" required>
                                    @for (comuna of comunas; track comuna) {
                                        <option [value]="comuna">{{ comuna }}</option>
                                    }
                                </select>
                            </div>
                            <div class="mt-3">
                                <label class="login-label" for="pais_env">País</label>
                                <input class="crm-input" name="pais_env" type="text" id="pais_env" [(ngModel)]="acc_request.pais_env" disabled>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
            }
            </div>
            }
            @if(step === 2){
            <div class="d-grid convert-tab mt-5">
                <div class="d-flex flex-row" style="column-gap: 8px;">
                    <img src="assets/svg/contact-icon-normal.svg" alt="">
                    <h6 class="text-semibold">Contacto</h6>
                </div>
                <div>
                    <img src="assets/svg/arrow-down-black.svg" alt="" class="center-svg">
                </div>
            </div>
            <div class="d-grid form-convert mt-3 gap-16">
                <div>
                    <label class="crm-radio-label">
                        <input type="radio" class="crm-radio" value="new" checked name="new-contact" [(ngModel)]="contactType">
                        <span class="crm-radio-custom"></span>
                        <h6 class="text-semibold">Crear nuevo contacto</h6>
                    </label>
                </div>
                <div>
                    <label class="crm-radio-label">
                        <input type="radio" class="crm-radio" value="existing" name="new-contact" [(ngModel)]="contactType">
                        <span class="crm-radio-custom"></span>
                        <h6 class="text-semibold">Elegir contacto existente</h6>
                    </label>
                </div>
            </div>
            <div class="step-2">
                @if(contactType === 'existing') {
                    <div class="main-step">
                        <h5 class="text-semibold mt-4">Seleccionar contacto existente</h5>
                        <div class="mt-3">
                            <div class="d-grid prospect-form">
                                <div>
                                    <label class="login-label" for="existing-contact"><span class="color-org">*</span> Búsqueda de contacto:</label>
                                    <div class="input-bordered">
                                        <div class="d-grid crm-ng-select">
                                            <div><img style="width: 30px;" src="assets/svg/contact-icon.svg" alt="icono asignado"></div>
                                            <div>
                                                <ng-select
                                                    *ngIf="contacts && contacts.length > 0"
                                                    [items]="contacts"
                                                    bindValue="contacto_id"
                                                    bindLabel="fullName"
                                                    placeholder="Seleccionar contacto..."
                                                    [(ngModel)]="contactoExistente"
                                                    [searchable]="true"
                                                    [clearable]="true">
                                                </ng-select>
                                                <div *ngIf="!contacts || contacts.length === 0" class="text-muted mt-2">
                                                    <small>No hay contactos disponibles</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                }
                @if(contactType === 'new') {
                <div class="main-step">
                    <h5 class="text-semibold mt-4">Información del contacto</h5>
                    <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div class="mt-3">
                            <label class="login-label" for="nombre_empresa"><span class="color-org" *ngIf="!cnt_request.cuenta_id || cnt_request.cuenta_id.trim() === ''">*</span> Nombre de la cuenta:</label>
                            <div class="input-bordered">
                                @if(accountType === 'existing') {
                                    <div class="d-grid crm-ng-select">
                                        <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                                        <div>
                                            <ng-select
                                                *ngIf="accounts"
                                                [items]="accounts"
                                                bindLabel="nombre_empresa"
                                                bindValue="cuenta_id"
                                                placeholder="Seleccionar cuenta..."
                                                [(ngModel)]="cuentaExistente"
                                                (ngModelChange)="actualizarPropietario($event)"
                                                [searchable]="false"
                                                [clearable]="false"
                                                [disabled]="step > 1">
                                            </ng-select>
                                        </div>
                                    </div>
                                } @else {
                                    <div class="d-grid crm-ng-select">
                                        <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                                        <div>
                                            <input 
                                                class="crm-input" 
                                                type="text" 
                                                [value]="acc_request.nombre_empresa" 
                                                readonly 
                                                placeholder="Cuenta que se creará..."
                                                style="background-color: #f5f5f5; cursor: not-allowed;">
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="propietario"><p class="color-org d-inline"></p>Propietario del contacto:</label>
                            <div class="d-flex flex-row align-items-center color-org gap-10">
                            <img src="assets/svg/avatar.svg" alt="">
                            <b><u>{{ propietarioContacto || 'Sin propietario' }}</u></b>
                            </div>
                        </div>
                        <div>
                        <div class="mt-3">
                            <label class="login-label" for="nombres"><span class="color-org" *ngIf="!cnt_request.nombre|| cnt_request.nombre.trim() === ''">*</span> Nombres:</label>
                            <input class="crm-input" type="text" name="nombres" id="nombres" [(ngModel)]="cnt_request.nombre" placeholder="María José" />
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="tratamiento">Tratamiento:</label>
                            <select class="crm-input" name="tratamiento" id="tratamiento" [(ngModel)]="cnt_request.tratamiento">
                            <option value="" disabled selected>-- Ninguno --</option>
                            <option value="Sr.">Sr.</option>
                            <option value="Sra.">Sra.</option>
                            <option value="Srta.">Srta.</option>
                            </select>
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="telefono">Teléfono:</label>
                            <input class="crm-input" type="text" name="telefono" id="telefono" [(ngModel)]="cnt_request.telefono" placeholder="+56 2 2134 5678" maxlength="12" />
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="correo">Correo:</label>
                            <input class="crm-input" type="email" name="correo" id="correo" [(ngModel)]="cnt_request.email" placeholder="example@gmail.com" />
                        </div>
                        </div>
                        <div>

                        <div class="mt-3">
                            <label class="login-label" for="apellidos"><span class="color-org" *ngIf="!cnt_request.apellido|| cnt_request.apellido.trim() === ''">*</span>Apellidos:</label>
                            <input class="crm-input" type="text" name="apellidos" id="apellidos" [(ngModel)]="cnt_request.apellido" placeholder="Ramírez Pérez" />
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="cargo"><span class="color-org" *ngIf="!cnt_request.cargo|| cnt_request.cargo.trim() === ''">*</span> Cargo:</label>
                            <input class="crm-input" type="text" name="cargo" id="cargo" [(ngModel)]="cnt_request.cargo" placeholder="Ejecutivo comercial" />
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="celular">Celular:</label>
                            <input class="crm-input" type="text" name="celular" id="celular" [(ngModel)]="cnt_request.celular" placeholder="+56 9 1234 5678" maxlength="12"/>
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="linkedin">LinkedIn:</label>
                            <input class="crm-input" type="text" name="linkedin" id="linkedin" [(ngModel)]="cnt_request.linkedin" placeholder="María José Ramírez" />
                        </div>
                        </div>
                    </div>

                    <h5 class="text-semibold mt-4">Información adicional</h5>
                    <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div>
                        <div class="mt-3">
                            <label for="fecha_nacimiento" class="login-label">Fecha de nacimiento:</label>
                            <input class="crm-input" type="date" id="fecha_nacimiento" [(ngModel)]="cnt_request.fecha_nacimiento" />
                        </div>
                        <div class="mt-3">
                            <label for="hobbie" class="login-label">Hobbie:</label>
                            <input class="crm-input" id="hobbie" [(ngModel)]="cnt_request.hobbie" placeholder="Agrega los hobbies del contacto (opcional)." rows="1">
                        </div>
                        </div>
                        <div>
                        <div class="mt-3">
                            <label for="aniversario_empresa" class="login-label">Aniversario de la empresa:</label>
                            <input class="crm-input" type="date" id="aniversario_empresa" [(ngModel)]="cnt_request.aniversario_empresa" />
                        </div>
                        <div class="mt-3">
                            <label for="genero" class="login-label">Identidad de género:</label>
                            <select class="crm-input" id="genero" [(ngModel)]="cnt_request.identidad_genero">
                            <option value="" disabled selected>Selecciona identidad de género</option>
                            <option value="Femenino">Femenino</option>
                            <option value="Masculino">Masculino</option>
                            <option value="Otro">Otro</option>
                            </select>
                        </div>
                        </div>
                    </div>

                    <h5 class="text-semibold mt-4">Dirección de envío</h5>
                    <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                        <div>
                        <div class="mt-3">
                            <label for="calle" class="login-label">Calle:</label>
                            <input class="crm-input" type="text" id="calle" [(ngModel)]="cnt_request.calle_env" placeholder="Av. Libertador 1234" />
                        </div>
                        <div class="mt-3">
                            <div class="mt-3">
                                <label class="login-label" for="">Region</label>
                                <select class="crm-input" name="" id="" [(ngModel)]="cnt_request.region_env" (change)="getComunas(cnt_request.region_env)">
                                    @for(item of regiones; track item.NombreRegion){
                                        <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                                        }
                                </select>
                            </div>
                        </div>
                        </div>
                        <div>
                        <div class="mt-3">
                            <label class="login-label" for="">Comuna</label>
                            <select class="crm-input" name="" id="" [(ngModel)]="cnt_request.ciudad_env">
                                @for (comuna of comunas; track comuna) {
                                <option [value]="comuna">{{ comuna }}</option>
                                }
                            </select>
                        </div>
                        <div class="mt-3">
                            <label class="login-label" for="">Pa&iacute;s</label>
                            <input class="crm-input" type="text" name="pais" id="pais" [value]="contacto?.pais" [(ngModel)]="cnt_request.pais" disabled>
                        </div>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
            @if(step === 3){
            <div class="d-grid convert-tab mt-5">
                <div class="d-flex flex-row" style="column-gap: 8px;">
                    <img src="assets/svg/opportunities-icon-normal.svg" alt="">
                    <h6 class="text-semibold">Oportunidad</h6>
                </div>
                <div>
                    <img src="assets/svg/arrow-down-black.svg" alt="" class="center-svg">
                </div>
            </div>
            <div class="d-grid form-convert convert-2 mt-3 gap-16">
                <div>
                    <label class="crm-radio-label">
                        <input type="radio" class="crm-radio" value="new" name="new-opportunity" [(ngModel)]="opportunityType">
                        <span class="crm-radio-custom"></span>
                        <h6 class="text-semibold">Crear nueva oportunidad</h6>
                    </label>
                </div>
                <div>
                    <label class="crm-radio-label">
                        <input type="radio" class="crm-radio" value="existing" name="new-opportunity" [(ngModel)]="opportunityType">
                        <span class="crm-radio-custom"></span>
                        <h6 class="text-semibold">Elegir oportunidad existente</h6>
                    </label>
                </div>
                <div>
                    <label class="crm-radio-label">
                        <input type="radio" class="crm-radio" value="none" name="new-opportunity" [(ngModel)]="opportunityType">
                        <span class="crm-radio-custom"></span>
                        <h6 class="text-semibold">No crear oportunidad</h6>
                    </label>
                </div>
            </div>

            <div class="step-3">
                @if(opportunityType === 'existing') {
                    <div class="main-step">
                        <h5 class="text-semibold mt-4">Seleccionar oportunidad existente</h5>
                        <div class="mt-3">
                            <div class="d-grid prospect-form">
                                <div>
                                    <label class="login-label" for="existing-opportunity"><span class="color-org">*</span> Búsqueda de oportunidad:</label>
                                    <div class="input-bordered">
                                        <div class="d-grid crm-ng-select">
                                            <div><img style="width: 30px;" src="assets/svg/opportunities-icon.svg" alt="icono asignado"></div>
                                            <div>
                                                <ng-select
                                                    *ngIf="opportunities && opportunities.length > 0"
                                                    [items]="opportunities"
                                                    bindValue="oportunidad_id"
                                                    bindLabel="nombre"
                                                    placeholder="Seleccionar oportunidad..."
                                                    [(ngModel)]="oportunidadExistente"
                                                    [searchable]="true"
                                                    [clearable]="true">
                                                </ng-select>
                                                <div *ngIf="!opportunities || opportunities.length === 0" class="text-muted mt-2">
                                                    <small>No hay oportunidades disponibles</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if(opportunityType === 'new') {
                <div class="main-step">
                <h5 class="text-semibold mt-4">Información de la oportunidad</h5>
                <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                    <div>
                    <div class="mt-3">
                        <label class="login-label"><p class="color-org d-inline">*</p> Nombre de la oportunidad:</label>
                        <input class="crm-input" type="text" [(ngModel)]="opp_request.nombre">
                    </div>
                    <div class="mt-3">
                        <label class="login-label"><p class="color-org d-inline">*</p> Tipo de negocio:</label>
                        <select class="crm-input" [(ngModel)]="opp_request.tipo_negocio">
                        <option value="Venta directa">Venta directa</option>
                        <option value="Distribuidor">Distribuidor</option>
                        <option value="Licencia">Licencia</option>
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Etapa:</label>
                        <select class="crm-input" name="" id="" [(ngModel)]="opp_request.id_estado">
                        @for (estado of opp_estados; track estado.id_estado) {
                            <option [value]="estado.id_estado">{{ estado.nombre }}</option>
                        }
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Importe:</label>
                        <input class="crm-input" type="number" [(ngModel)]="opp_request.importe_actual">
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Propietario:</label>
                        <div class="d-flex flex-row align-items-center color-org gap-10">
                        <img src="assets/svg/avatar.svg" alt=""><b><u>Juan Soto</u></b>
                        </div>
                    </div>
                    </div>

                    <div>
                    <div class="mt-3">
                        <label class="login-label" for="nombre_cuenta"><span class="color-org" *ngIf="!opp_request.cuenta_id || opp_request.cuenta_id.trim() === ''">*</span> Nombre de la cuenta:</label>
                        <div class="input-bordered">
                            @if(accountType === 'existing') {
                                <div class="d-grid crm-ng-select">
                                    <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                                    <div>
                                        <ng-select
                                            *ngIf="accounts"
                                            [items]="accounts"
                                            bindLabel="nombre_empresa"
                                            bindValue="cuenta_id"
                                            placeholder="Seleccionar cuenta..."
                                            [(ngModel)]="cuentaExistente"
                                            [searchable]="false"
                                            [clearable]="false"
                                            [disabled]="step > 1">
                                        </ng-select>
                                    </div>
                                </div>
                            } @else {
                                <div class="d-grid crm-ng-select">
                                    <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                                    <div>
                                        <input 
                                            class="crm-input" 
                                            type="text" 
                                            [value]="acc_request.nombre_empresa" 
                                            readonly 
                                            placeholder="Cuenta que se creará..."
                                            style="background-color: #f5f5f5; cursor: not-allowed;">
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Fecha de cierre:</label>
                        <input class="crm-input" type="date" [(ngModel)]="opp_request.fecha_cierre_estimada" [min]="today">
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Probabilidad (%):</label>
                        <input class="crm-input" type="number" [(ngModel)]="opp_request.probabilidad_cierre">
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Siguiente paso:</label>
                        <input class="crm-input" type="text" [(ngModel)]="opp_request.sgte_paso">
                    </div>
                    </div>
                </div>

                <h5 class="text-semibold mt-4">Información adicional</h5>
                <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                    <div>
                    <div class="mt-3">
                        <label class="login-label">Categoría de previsión:</label>
                        <select class="crm-input" [(ngModel)]="opp_request.categoria_prevision">
                        <option value="Alta">Alta</option>
                        <option value="Media">Media</option>
                        <option value="Baja">Baja</option>
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Motivo de la pérdida:</label>
                        <input class="crm-input" type="text" [(ngModel)]="opp_request.motivo_perdida">
                    </div>
                    </div>
                    <div>
                    <div class="mt-3">
                        <label class="login-label">Tipo:</label>
                        <select class="crm-input" [(ngModel)]="opp_request.tipo_oportunidad">
                        <option value="Producto">Producto</option>
                        <option value="Servicio">Servicio</option>
                        <option value="Mixto">Mixto</option>
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">Descripción:</label>
                        <input class="crm-input" [(ngModel)]="opp_request.descripcion">
                    </div>
                    </div>
                </div>

                <h5 class="text-semibold mt-4">Otra información</h5>
                <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                    <div class="mt-3">
                    <label class="login-label">Contrato:</label>
                    <input class="crm-input" type="text" [(ngModel)]="opp_request.contrato">
                    </div>
                    <div class="mt-3">
                    <label class="login-label">Presupuesto sincronizado:</label>
                    <input class="crm-input" type="text" [(ngModel)]="opp_request.presupuesto_sincronizado">
                    </div>
                </div>
                </div>
            }
            </div>
        }

            @if(step === 4){
            <div class="step-4">
                <div class="main-step">
                    <!-- Cards horizontales -->
                    <div class="summary-cards-container">
                        <!-- Card de Empresa -->
                        <div class="summary-card">
                            <div class="card-header">
                                <img src="assets/svg/account.svg" alt="">
                                <h6 class="card-title">{{acc_request.nombre_empresa || 'Empresa Siroe'}}</h6>
                            </div>
                            <div class="summary-grid">
                                <div>
                                    <span class="label-text">Teléfono</span>
                                    <span class="value-text">{{acc_request.telefono || '+56 9 1234 5678'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Dirección de facturación</span>
                                    <span class="value-text">{{acc_request.direccion_fact || 'Av. Apoquindo #123, Las Condes.'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Sitio web</span>
                                    <span class="value-text">{{acc_request.sitio_web || 'www.siroe.cl'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Propietario de la cuenta</span>
                                    <span class="value-text propietary color-orange">{{loggedUserName || 'Juan Soto'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Card de Contacto -->
                        <div class="summary-card">
                            <div class="card-header">
                                <img src="assets/svg/contact-icon-normal.svg" alt="">
                                <h6 class="card-title">{{cnt_request.nombre || 'Sebastián'}} {{cnt_request.apellido || 'Pérez'}}</h6>
                            </div>
                            <div class="summary-grid">
                                <div>
                                    <span class="label-text">Cargo</span>
                                    <span class="value-text">{{cnt_request.cargo || 'Gerente comercial'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Nombre de la empresa</span>
                                    <span class="value-text propietary color-orange">{{acc_request.nombre_empresa || 'Empresa Siroe'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Teléfono</span>
                                    <span class="value-text">{{cnt_request.telefono || '+56 9 1234 5678'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Correo</span>
                                    <span class="value-text">{{cnt_request.email || 's.perez@siroe.cl'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Card de Oportunidad -->
                        <div class="summary-card">
                            <div class="card-header">
                                <img src="assets/svg/opportunities-icon-normal.svg" alt="">
                                <h6 class="card-title">{{opp_request.nombre || 'Nueva Oportunidad'}}</h6>
                            </div>
                            <div class="summary-grid">
                                <div>
                                    <span class="label-text">Tipo de negocio</span>
                                    <span class="value-text">{{opp_request.tipo_negocio || 'Servicio'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Importe</span>
                                    <span class="value-text">{{opp_request.importe_actual || 0 | currency:'CLP':'symbol':'1.0-0'}}</span>
                                </div>
                                <div>
                                    <span class="label-text">Probabilidad</span>
                                    <span class="value-text">{{opp_request.probabilidad_cierre || 0}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            <hr class="mt-3 mb-3">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                @if(step === 4){
                    <button type="button" class="btn btn-primary-outline" (click)="openCreateTaskMdl()">
                        Crear nueva tarea
                    </button>
                    <button type="button" class="btn btn-primary" (click)="goToProspectsPage()">
                        Ir a prospectos
                    </button>
                }@else{
                    <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
                    @if(step < 3){
                        <button type="button" class="btn btn-primary" (click)="nextStep()">Siguiente</button>
                    }@else{ 
                        <button type="submit" class="btn btn-primary" (click)="convertProspect()">Convertir prospecto</button>
                    }
                }
            </div>
        </div>
    </div>
</div>  